/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetSubtitleLink
 */
export interface AssetSubtitleLink {
    /**
     * 
     * @type {number}
     * @memberof AssetSubtitleLink
     */
    readonly id?: number;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof AssetSubtitleLink
     */
    subtitle: AssetMiniReference;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLink
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLink
     */
    key: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSubtitleLink
     */
    asset: number;
}

export function AssetSubtitleLinkFromJSON(json: any): AssetSubtitleLink {
    return AssetSubtitleLinkFromJSONTyped(json, false);
}

export function AssetSubtitleLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSubtitleLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'subtitle': AssetMiniReferenceFromJSON(json['subtitle']),
        'label': json['label'],
        'key': json['key'],
        'asset': json['asset'],
    };
}

export function AssetSubtitleLinkToJSON(value?: AssetSubtitleLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtitle': AssetMiniReferenceToJSON(value.subtitle),
        'label': value.label,
        'key': value.key,
        'asset': value.asset,
    };
}


